
import CheckInCustomerDetailsContainer from 'containers/CheckInCustomerDetails/index'
import React from 'react'

const CheckInCustomerDetails =(props)=> {
  return (
<CheckInCustomerDetailsContainer  {...props}/>

  )
}

export default CheckInCustomerDetails
